// import React, {Component} from "react";
import { Tab, TabPanel, Tabs, TabList } from "react-web-tabs";
// import ReactDOM from "react-dom";
import "react-web-tabs/dist/react-web-tabs.css";
import config from 'react-global-configuration';
import {Link} from "react-router-dom";
import {Nav, Navbar, NavItem} from "react-bootstrap";
import React, {Component, useState} from 'react';
import axios from "axios";
import $ from 'jquery';
import {Button, Collapse, Input, Label, Modal, ModalBody, ModalFooter, Card, CardBody, CardText} from 'reactstrap';
import Switch from 'react-switch';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
//import {confirmAlert} from 'react-confirm-alert';
import ReactTooltip from 'react-tooltip';
import jwt_decode from "jwt-decode";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SimpleReactValidator from 'simple-react-validator';
import AsyncPaginate, {reduceGroupedOptions} from 'react-select-async-paginate';
import moment from 'moment';
import CommonNavbar, {navbar} from "./commonNavbar";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import {List} from "react-virtualized";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class NewViewPromotion extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            activer: [],
            isEMI: [],
            isUpfront: [],
            zeroCost: [],
            _notificationSystem: null,
            mapField: false,
            maxTxnAmount: 10000,
            selectedBrandSubvention: 'Percent',
            selectedBankSubvention: 'NA',
            selectedMerchantSubvention: 'All_Level',
            selectedState: [],
            selectedCity: [],
            merchant_disabler: true,
            brand_subvention_list:{},
            bank_subvention_list: [],
            brand_subvention_value: {},
            bank_subvention_value: [],
            maximum_cashback: [],
            disabler_list: [true, true, true, true, true, true, true, true, true, true, true, true],
            mapField2: false,
            startDate: moment(new Date()).format('YYYY-MM-DD'),
            endDate: moment(new Date()).format('YYYY-MM-DD'),
            sku_showModel: false,
            sku_list: [],
            raw_display_data: [],
            state_display_data: [],
            city_display_data: [],
            merchant_display_data: [],
            chain_display_data: [],
            store_display_data: [],
            state_loaded: false,
            city_loaded: false,
            sku_monitor: 0,
            selectedMerchValues: [],
            selectedRefineSubvention: [],
            slicedMerchValues: [],
            the_bank_list: {},
            bank_name_list1: {},
            refineSearch: false,
            state_ida: '',
            city_ida: '',
            merchant_ida: '',
            chain_ida: '',
            refinerMerch: [false, false, false, false, false],
            valuera: null,
            mapField3: false,
            mapField0: false,
            brand_has_merchant: [],
            stepper: [false, true, true, true],
            current_tab: 'vertical-tab-one',
            campaign_name: '',
            campaign_desc: '',
            merchant_length: null,
            merchant_counter: 1,
            merchant_counter_array: [0],
            follower: false,
            scheme_id: 0,
            scheme_display_data: [],
            sku_display_data: [],
            campaign_display_data: [],
            scheme_active: 0,
            merchant_file_uploaded: null,
            scheme_mapping_uploaded: null,
            is_download2: false,
            scheme_master_list:[],
            scheme_master_data: [],
            merchant_master_data: [],
            activer7: [],
            merchant2_display_data: [],
            merchant_master_list: [],
            party_id_mapper: [],
            party_master_id: null,
            reason: null,
            emiMenus:[],
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:[],
            chainValue:[],
            storeList:[],
            storeValue: [],
            merchant_table_master_data: null,
            
            //redirect = false
        };
        this.myRef = React.createRef();
        this.myRef2 = React.createRef();
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount(){
        this.setState({ 
            scheme_id: this.props.match.params.id,
            _notificationSystem: this.refs.notificationSystem
        })
        this.getPartyID();
        this._getAllMerchantsTable();
        //this._getAllMerchants1();
        this._refreshSku_Show_View_Promotion();
        this.getSchemeMasterDataView();
        
        //var _notificationSystem = this.refs.notificationSystem;
        this.validator = new SimpleReactValidator();
    }


    _getAllMerchantsTable(){
        if ($.fn.DataTable.isDataTable('#brandMerchantMasterViewTable')) {
            $('#brandMerchantMasterViewTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL') + '/brandemi/download_promotion_merchant_details_table',
        {   
            promotion_id: this.props.match.params.id
        },
         {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            this.setState({
                merchant_master_data: response.data.data
            });
            $('#brandMerchantMasterViewTable').DataTable();
        });
        return null
    }

    // _getAllMerchants(){
    //     axios.post(config.get('API_URL')+'/brandemi/get-merchant',{},{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         }
    //     }).then(response => {
    //         console.log(response.data);
    //         if(Array.isArray(response.data) && response.data.length) {

    //             response.data.map((merchant, index) => {
    //                 this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
    //             });
    //         }
    //     });
    // }

    // _getAllMerchants1(){
    //     axios.post(config.get('API_URL')+'/brandemi/get-merchant',{},{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         }
    //     }).then(response => {
    //         console.log(response.data);
    //         if(Array.isArray(response.data) && response.data.length) {

    //             response.data.map((merchant, index) => {
    //                 this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
    //             });
    //         }
    //         this.getMerchantData();
    //     });
    // }

    // changeMerchant1(optionSelected){
    //     console.log(optionSelected);
    //     let value='';
    //     let midArray = [];
    //     if(optionSelected.length<1){
    //         value = null;
    //         midArray = '';
    //     }
    //     else{
    //         optionSelected.map((mids, i) => {
    //             midArray.push(mids.value)
    //             var index = this.state.merchantList.findIndex(obj => obj.value==mids.value);
    //             this.state.merchantList.move(index,0).join(',');
    //         });
    //     }
    //     this.setState({
    //         merchantID:midArray,
    //         chainID:'',
    //         merchantValue:optionSelected,
    //         chainValue:[],
    //         storeID:'',
    //         storeValue: []
    //     }, () =>{
    //         this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
    //         this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);
    //     });
    //     //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);

    // }

    // getChain(code, type, object_type, object_code){
    //     axios.post(config.get('API_URL')+'/brandemi/get-chain',{
    //             code: code,
    //             type: type,
    //             object_type: object_type,
    //             object_code: object_code
    //         },
    //         {
    //             headers: {
    //                 Authorization: ` ${localStorage.usertoken}`
    //             },

    //         }).then(response => {
    //         let chalinList = [];
    //         this.setState({chainID:''});
    //         console.log(response.data);
    //         response.data.map((chain,index) => {
    //             chalinList.push({value: chain.chain_code, label: chain.chain_name, value1: chain.merchant_code, merch_name: chain.merchant_name})
    //         });
    //         this.setState({
    //             chainList:chalinList
    //         })
    //     });
    // }

    // getChain1(code, type, object_type, object_code){
    //     axios.post(config.get('API_URL')+'/brandemi/get-chain',{
    //             code: code,
    //             type: type,
    //             object_type: object_type,
    //             object_code: object_code
    //         },
    //         {
    //             headers: {
    //                 Authorization: ` ${localStorage.usertoken}`
    //             },

    //         }).then(response => {
    //         let chalinList = [];
    //         this.setState({chainID:''});
    //         console.log(response.data);
    //         response.data.map((chain,index) => {
    //             chalinList.push({value: chain.chain_code, label: chain.chain_name, value1: chain.merchant_code, merch_name: chain.merchant_name})
    //         });
    //         this.setState({
    //             chainList:chalinList
    //         }, () =>{
    //             this.getChainData();
    //             //this.
    //         })
    //     });
    // }

    // changeChain(optionSelected) {
    //     let value='';
    //     let cidArray = [];
    //     if(optionSelected.length<1){
    //         value = null;
    //         cidArray = '';
    //     }
    //     else{
    //         optionSelected.map((cids, i) => {
    //             cidArray.push(cids.value)
    //             var index = this.state.chainList.findIndex(obj => obj.value==cids.value);
    //             this.state.chainList.move(index,0).join(',');
    //         });
    //     }

    //     this.setState({
    //         chainID: cidArray,
    //         chainValue:optionSelected,
    //         storeID:'',
    //         storeValue: []
    //     });

    //     //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);

    //     this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID);


    // }

    // getStore(code, type, object_type, object_code) {
    //     axios.post(config.get('API_URL')+'/brandemi/get-store', {
    //             code: code,
    //             type: type,
    //             object_type: object_type,
    //             object_code: object_code
    //         },
    //         {
    //             headers: {
    //                 Authorization: ` ${localStorage.usertoken}`
    //             }

    //         }).then(response => {
    //         let storeList = [];
    //         this.setState({storeID:''});
    //         console.log(response.data);
    //         response.data.map((store,index) => {
    //             storeList.push({value: store.store_code, label: store.store_name, value1:store.merchant_code, value2: store.chain_code, chain_name: store.chain_name, merch_name: store.merchant_name})
    //         });
    //         this.setState({
    //             storeList:storeList
    //         })
    //     });
    // }


    // getStore1(code, type, object_type, object_code) {
    //     axios.post(config.get('API_URL')+'/brandemi/get-store', {
    //             code: code,
    //             type: type,
    //             object_type: object_type,
    //             object_code: object_code
    //         },
    //         {
    //             headers: {
    //                 Authorization: ` ${localStorage.usertoken}`
    //             }

    //         }).then(response => {
    //         let storeList = [];
    //         this.setState({storeID:''});
    //         console.log(response.data);
    //         response.data.map((store,index) => {
    //             storeList.push({value: store.store_code, label: store.store_name, value1:store.merchant_code, value2: store.chain_code, chain_name: store.chain_name, merch_name: store.merchant_name})
    //         });
    //         this.setState({
    //             storeList:storeList
    //         }, () =>{
    //             this.getStoreData();
    //         })
    //     });
    // }

    // changeStore(optionSelected) {
    //     let value='';
    //     let sidArray = [];
    //     if(optionSelected.length<1){
    //         value = null;
    //         sidArray = '';
    //     }
    //     else{
    //         optionSelected.map((sids, i) => {
    //             sidArray.push(sids.value)
    //             var index = this.state.storeList.findIndex(obj => obj.value==sids.value);
    //             this.state.storeList.move(index,0).join(',');
    //         });
    //     }
    //     this.setState({
    //         storeID: sidArray,
    //         storeValue:optionSelected
    //     });
    //     //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);
    //     // this._get_filtered_emi_scheme_report(this.state.merchantID, this.state.chainID, sidArray, this.state.acqBankIds, this.state.cityIds,this.state.frequency,
    //     //     this.state.yestSend, this.state.todSend);
    // }

    // getMerchantData(){
    //     axios.post(config.get('API_URL')+'/brandemi/get-promotion-merchant',{
    //         id: this.props.match.params.id
    //     },{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         }
    //     }).then(response => {
    //         console.log(response.data);
    //         if(Array.isArray(response.data) && response.data.length) {
    //             let value='';
    //             let midArray = [];
    //             let optionSelected = [];
    //             response.data.map((mids, i) => {
    //                 midArray.push(mids.merchant_code)
    //                 var index = this.state.merchantList.findIndex(obj => obj.value==mids.merchant_code);
    //                 this.state.merchantList.move(index,0).join(',');
    //                 optionSelected.push({value: mids.merchant_code, label: mids.merchant_name})
    //             });
    //             console.log(midArray);
    //             console.log(optionSelected);
    //             this.setState({
    //                 merchantID:midArray,
    //                 chainID:'',
    //                 merchantValue:optionSelected,
    //                 chainValue:[],
    //                 storeID:'',
    //                 storeValue: []
    //             }, () =>{
    //                 this.getChain1(midArray, 'merchant', this.state.object_type, this.state.object_code);
    //                 this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);
    //             // response.data.map((merchant, index) => {
    //             //     this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
    //             // });
    //             });
    //         }
    //         });
    //     }
    
    // getChainData(){
    //     axios.post(config.get('API_URL')+'/brandemi/get-promotion-chain',{
    //         id: this.props.match.params.id
    //     },{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         }
    //     }).then(response => {
    //         console.log(response.data);
    //         if(Array.isArray(response.data) && response.data.length) {
    //             let cidArray = [];
    //             let optionSelected = [];
    //             if(response.data[0]['chain_code'] == 9){
    //                 console.log("Yay");
    //             }
    //             else{
    //                 response.data.map((cids, i) => {
    //                     cidArray.push(cids.chain_code)
    //                     var index = this.state.chainList.findIndex(obj => obj.value==cids.chain_code);
    //                     this.state.chainList.move(index,0).join(',');
    //                     optionSelected.push({value: cids.chain_code, label: cids.chain_name, value1: cids.merchant_code, merch_name: cids.merchant_name })
    //                 });
    //                 this.setState({
    //                     chainID: cidArray,
    //                     chainValue:optionSelected,
    //                     storeID:'',
    //                     storeValue: []
    //                 }, () => {
    //                     this.getStore1(cidArray, 'chain', this.state.object_type, this.state.merchantID);
    //                 });
    //             }
    //         }
    //         });
    //     }

    // getStoreData(){
    //     axios.post(config.get('API_URL')+'/brandemi/get-promotion-store',{
    //         id: this.props.match.params.id
    //     },{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         }
    //     }).then(response => {
    //         console.log(response.data);
    //         if(Array.isArray(response.data) && response.data.length) {
    //             let value='';
    //             let sidArray = [];
    //             let optionSelected = [];
    //             console.log(response.data);
    //             if(response.data[0]['store_code'] == 9){
    //                 console.log("Yay");
    //             }
    //             else{
    //                 response.data.map((sids, i) => {
    //                     sidArray.push(sids.store_code)
    //                     var index = this.state.storeList.findIndex(obj => obj.value==sids.store_code);
    //                     this.state.storeList.move(index,0).join(',');
    //                     optionSelected.push({value: sids.store_code, label: sids.store_name, value1: sids.merchant_code, value2: sids.chain_code, merch_name: sids.merchant_name, chain_name: sids.chain_name});
    //                 });
                    
    //                 this.setState({
    //                     storeID: sidArray,
    //                     storeValue:optionSelected
    //                 });
    //             }
    //         }
    //         });
    //     }

    //get the list of schemes uploaded by user
    // getSchemeMasterDataView(){
    //     if ($.fn.DataTable.isDataTable('#brandSchemeMasterViewTable')) {
    //         $('#brandSchemeMasterViewTable').DataTable().destroy();
    //     }
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     axios.get(config.get('API_URL') + '/brandemi/get_new_schemes_master', {
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //         params: {
    //             party_master_id: this.state.party_master_id
    //         }
    //     }).then(response => {
    //         console.log(response);
    //         response.data.map((value, index) => {
    //             let status = false;
    //             if(value.active_status===1) { status = true;}
    //             this.setState({
    //                 activer: {...this.state.activer, [index]:status }
    //             });
    //         });
    //         this.setState({
    //             scheme_master_data: response.data
    //         });
    //         $('#brandSchemeMasterViewTable').DataTable();
    //     });
    //     return null;
    // }

    getSchemeMasterDataView(){
        if ($.fn.DataTable.isDataTable('#brandSchemeMasterViewTable')) {
            $('#brandSchemeMasterViewTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL') + '/brandemi/view_brand_schemes_promotion',
        {   
            promotion_id: this.props.match.params.id
        },
         {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            this.setState({
                scheme_master_data: response.data.data
            });
            $('#brandSchemeMasterViewTable').DataTable();
        });
        return null
    }

    //get merchants configured in backend
    // getMerchantMappingData(){
    //     if(this.state.party_master_id != null){
    //         if ($.fn.DataTable.isDataTable('#brandMerchantMasterViewTable')) {
    //             $('#brandMerchantMasterViewTable').DataTable().destroy();
    //         }
    //         const token = localStorage.usertoken;
    //         const decoded = jwt_decode(token);
    //         axios.get(config.get('API_URL') + '/brandemi/view_merchant_maintainer',{
    //             headers: {
    //                 Authorization: ` ${localStorage.usertoken}`
    //             },
    //             params: {
    //                 party_master_id: this.state.party_master_id
    //             }
    //         }).then(response => {
    //             this.setState({
    //                 merchant2_display_data: response.data
    //             });
    //             $('#brandMerchantMasterViewTable').DataTable();
    //             this.setState({
    //                 loading: false,
    //                 user_id: decoded._id
    //             });
    //         });
    //     }
    // }

    //get partyID of user
    getPartyID(){
        if ($.fn.DataTable.isDataTable('#party_showTable')) {
            $('#party_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
            }
        }).then(response => {
            response.data.map((values, index) => {
                console.log(values.party_id);
                this.setState({
                    party_master_id: values.party_id
                })
            })
            this.setState({
                party_id_mapper: response.data
            });
            $('#party_showTable').DataTable();
            this.setState({
                loading: false,
                user_id: decoded._id
            });
            //this._refreshSku_Show_View();
            //this._getSchemeData();
            //this._getSkuData();
            //this._getSchemeDetails();
            this._getCampaignData();
            this._getMerchantFileUploaded();
            this._getSchemeMappingUploaded();
            //this.getSchemeMasterDataView();
            //this._getMerchantDetails();
            //this.getMerchantMappingData();
        });
    }

    // get selected schemes for that campaign
    // _getSchemeDetails(){
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     axios.get(config.get('API_URL') + '/brandemi/get_scheme_details',{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //         params: {
    //             id: this.props.match.params.id,
    //         }
    //     }).then(response => {
    //         console.log(response);
    //         response.data.map((values, index) => {
    //             this.setState({
    //                 scheme_master_list: {...this.state.scheme_master_list, [values.scheme_id]: true}
    //             })
    //         })
    //         console.log("DOne");    
    //     });
    // }

    //get selected merchants for the campaign
    _getMerchantDetails(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_merchant_details',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                id: this.props.match.params.id,
            }
        }).then(response => {
            console.log(response);
            response.data.map((values, index) => {
                this.setState({
                    merchant_master_list: {...this.state.merchant_master_list, [values.merchant_data_id]: true}
                })
            })
            console.log("DOne");    
        });
    }


    _getMerchantFileUploaded(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_merchant_master',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                id: this.props.match.params.id,
            }
        }).then(response => {
            console.log(response);
            response.data.map((values, index) => {
                this.setState({
                    merchant_file_uploaded: values.stored_file_name
                })
            })
            console.log("DOne");    
        });
    }

    _getSchemeMappingUploaded(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_scheme_mappings',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                id: this.props.match.params.id,
            }
        }).then(response => {
            //console.log(response.data);
            console.log(response);
            response.data.map((values, index) => {
                this.setState({
                    scheme_mapping_uploaded: values.stored_file_name
                })
            })
            console.log("Done");
        });
    }

    //get selected products of campaign/promotion
    // _getSkuData(){
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     axios.get(config.get('API_URL') + '/brandemi/get_scheme_sku_data',{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //         params: {
    //             campaignID: this.props.match.params.id,
    //         }
    //     }).then(response => {
    //         console.log(response);
    //         response.data.map((values, index) => {
    //             this.setState({
    //                 sku_list: {...this.state.sku_list, [values.sku]:true}
    //             })
    //         })
    //         this.setState({
    //             sku_display_data: response.data
    //         });
    //         console.log("DOne");
    //     });
    // }


    //get details of campaign/promotion metadata, get id so that we can get selected products, schemes and merchants of that campaign/promotion
    _getCampaignData(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_campaign_data',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                id: this.props.match.params.id,
            }
        }).then(response => {
            //console.log(response.data);
            console.log(response);
            response.data.map((values, index) => {
                if(index == 0){
                    this.setState({
                        campaign_name: values.campaign_name,
                        campaign_desc: values.campaign_desc,
                        startDate: values.start_date,
                        endDate: values.end_date,
                        maxTxnAmount: values.max_cashback,
                        scheme_active: values.active,
                        reason: values.reason
                    })
                }
            })
            this.setState({
                campaign_display_data: response.data,
                loading: false
            });
            console.log("DOne");    
        });
    }

    //get list of all possible products for brand
    // _refreshSku_Show_View() {
    //     if ($.fn.DataTable.isDataTable('#sku_showTable')) {
    //         $('#sku_showTable').DataTable().destroy();
    //     }
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     axios.get(config.get('API_URL') + '/brandemi/view_brand_sku',{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //         params: {
    //             party_master_id: this.state.party_master_id
    //         }
    //     }).then(response => {
    //         //console.log(response.data);
    //         this.setState({
    //             raw_display_data: response.data
    //         });
    //         $('#sku_showTable').DataTable();
    //     });
    // }

    _refreshSku_Show_View_Promotion() {
        if ($.fn.DataTable.isDataTable('#sku_showTable')) {
            $('#sku_showTable').DataTable().destroy();
        }
        console.log(this.state.brand_user_id);
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL') + '/brandemi/view_brand_sku_promotion',
        {
            promotion_id: this.props.match.params.id
        },
        {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            this.setState({
                raw_display_data: response.data.data
            });
            $('#sku_showTable').DataTable();
        });
    }

    handleFromChange = date => {
        this.setState({
            startDate: moment(date).format('YYYY-MM-DD'),
            mapField2: false
        });
    };

    handleToChange = date => {
        this.setState({
            endDate: moment(date).format('YYYY-MM-DD'),
            mapField2: false
        });
    };


    openSectionToMap = (status) => {
        this.setState({
            mapField: status
        })
    };
    

    updateMapVisiblity = (value) => {
        this.setState({
            mapField: value
        })
    };

    changeActiver(index, checked) {
        this.setState({
            activer: {...this.state.activer, [index]:checked.target.checked },
            mapField: false

        });
    }
   
    tabClicker(value){
        if(value == 1){
            this.setState({
                stepper: {...this.state.stepper, [1]: true},
                stepper: {...this.state.stepper, [2]: true},
                stepper: {...this.state.stepper, [3]: true}
            })
        }
    }

    render() {

        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }

        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
                margin: "0px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px",
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px",
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "15px",
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px',
            }),
            menu: styles => ({ ...styles, zIndex: 999})
        };


        let merchant_displayer = () => {
            if(decoded.userGroup == 2 || decoded.userGroup == '2'){
                return(<div></div>)
            }
            else{
                return(
                    <div className="row">
                        <div className="col-md-4">
                            <Label>Select Merchant:</Label>
                            <ReactMultiSelectCheckboxes name={"merchant_selector"}
                                                        components={{ MenuList }}
                                                        isClearable={false}
                                                        onChange={this.changeMerchant1.bind(this)}
                                                        styles={customStyles} className="report-listbox"
                                                        options={this.state.merchantList}
                                                        value={this.state.merchantValue}
                                                        isMulti
                                                        placeholderButtonLabel="All"
                            />
                        </div>
                        <div className="col-md-4">
                            <Label>Select Chain:</Label>
                            <ReactMultiSelectCheckboxes name={"chain_selector"}
                                                        components={{ MenuList }}
                                                        isClearable={false}
                                                        onChange={this.changeChain.bind(this)}
                                                        styles={customStyles} className="report-listbox"
                                                        options={this.state.chainList}
                                                        value={this.state.chainValue}
                                                        isMulti
                                                        placeholderButtonLabel="All"
                            />
                        </div>
                        <div className="col-md-4">
                            <Label>Select Store:</Label>
                            <ReactMultiSelectCheckboxes name={"store_selector"}
                                                        components={{ MenuList }}
                                                        isClearable={false}
                                                        onChange={this.changeStore.bind(this)}
                                                        styles={customStyles} className="report-listbox"
                                                        options={this.state.storeList}
                                                        value={this.state.storeValue}
                                                        isMulti
                                                        placeholderButtonLabel="All"
                            />
                        </div>
                    </div>
                )
            }
        }



        let scheme_data_master = this.state.scheme_master_data.map((value, index) =>{
            let timer2 = new Date(value.record_update_timestamp)
            timer2.setHours( timer2.getHours() + 5 );
            timer2.setMinutes( timer2.getMinutes() + 30 );
            // timer
            let timer3 = timer2.toJSON().slice(0, 19).replace('T', ' ');
            let cashback_render = '';
            let brand_sub_render = value.brand_sub;
            let brand_sub_amount_render = value.brand_sub_amount;
            let tenure_render = value.tenure;
            let emi_typea = 'Non EMI';
            if (value.is_emi == 0 || value.is_emi == '0'){
                tenure_render = 'NA';
            }
            else if(value.is_emi == 1 || value.is_emi == '1'){
                emi_typea = 'Zero Cost' 
            }
            else if(value.is_emi == 2 || value.is_emi == '2'){
                emi_typea = 'Low Cost' 
            }
            if (value.is_cashback == 0 || value.is_cashback == '0'){
                cashback_render = 'No';
                brand_sub_render = 'NA';
                brand_sub_amount_render = 'NA';
            }
            else{
                cashback_render = 'Yes';
            }
            let max_cashback_render = value.max_cashback.slice(0, -1);
            //if(max_cashback_render == -1 || max_cashback_render == '-1'){
            if(max_cashback_render == '0.00'){
                max_cashback_render = 'NA';
            }
            return (
                <tr key={index + 1}>
                    <td>{value.scheme_name}</td>
                    <td>{value.bank_name}</td>
                    <td>{(value.is_emi)? 'Y' : 'N'}</td>
                    <td>{tenure_render}</td>
                    <td>{cashback_render}</td>
                    <td>{brand_sub_render}</td>
                    <td>{brand_sub_amount_render}</td>
                    <td>{max_cashback_render}</td>
                    <td>{timer3}</td>
                    <td>{'Yes'}</td>
                </tr>
                )
        });

        // let merchant_data_master = null;
        // if(this.state.party_master_id != null && this.state.merchant2_display_data.length != 0){
        //     merchant_data_master = this.state.merchant2_display_data.map((value, index) =>{
        //             return (
        //                 <tr key={index + 1}>
        //                 <td>{value.merchant_id}</td>
        //                 <td>{value.merchant_name}</td>
        //                 <td>{value.merchant_code}</td>
        //                 <td>{value.chain_id}</td>
        //                 <td>{value.chain_name}</td>
        //                 <td>{value.chain_code}</td>
        //                 <td>{value.store_id}</td>
        //                 <td>{value.store_name}</td>
        //                 <td>{value.store_code}</td>
        //                 <td>{value.store_address}</td>
        //                 <td>{value.field_1}</td>
        //                 <td>{(this.state.merchant_master_list[value.id]) ? 'Yes' : 'No'}</td>
        //             </tr>
        //             )
        //     }); 
        // }

        let bank_activer = this.state.activer;
        let start_date = (this.state.startDate);
        let end_date = new Date(this.state.endDate);
        end_date.setDate( end_date.getDate() - 1 );
        let end_date2 = end_date;
        let max_txn = this.state.maxTxnAmount;

        let sku_show_data = this.state.raw_display_data.map((value,index) => {
                return (
                    <tr key={index + 1}>
                    <td>{index+1}</td>
                    <td>{value.brand}</td>
                    <td>{value.category}</td>
                    <td>{value.model_name}</td>
                    <td>{value.model_number}</td>
                    <td>{value.model_description}</td>
                    <td>{value.sku}</td>
                    <td>{value.mrp}</td>
                    <td>{value.mop}</td>
                    <td>{'Yes'}</td>
                </tr>
                );
        });
   
        let variabler = this.state.current_tab;
        let active_finder = '';
        if (this.state.scheme_active == 1 || this.state.scheme_active == '1'){
            active_finder = ' - Approved';
        }
        else if(this.state.scheme_active == 0 || this.state.scheme_active == '0'){
            active_finder = ' - Created';
        }
        else if(this.state.scheme_active == 2 || this.state.scheme_active == '2'){
            active_finder = ' - Configured';
        }
        else if(this.state.scheme_active == 3 || this.state.scheme_active == '3'){
            active_finder = ' - QA verified';
        }
        else if(this.state.scheme_active == 4 || this.state.scheme_active == '4'){
            active_finder = ' - Active';
        }
        else if(this.state.scheme_active == -1 || this.state.scheme_active == '-1'){
            active_finder = ' - Rejected';
        }
        else{
            active_finder = ' - Expired';
        }
        let campaign_header = this.state.campaign_name + active_finder;

        let reason_giver = () => {
            if (this.state.scheme_active == -1 || this.state.scheme_active == '-1'){
                return(
                    <div className="row bottompaddingsubvention">
                        <div className=" col-sm-6 col-md-3 col-xs-12">
                            <Label>Reason</Label>
                            <Input id="reason" className="maxheighter" value={this.state.reason} disabled={true}/>  
                        </div>
                    </div>
                )
            }
            else{
                return(
                    <div></div>
                )
            }
        }

        let merchant_table_displayer = this.state.merchant_master_data.map((value, index) =>{
            return (
                <tr key={index + 1}>
                    <td>{value.merchant_name}</td>
                    <td>{value.merchant_code}</td>
                    <td>{value.chain_name}</td>
                    <td>{value.chain_code}</td>
                    <td>{value.store_name}</td>
                    <td>{value.store_code}</td>
            </tr>
            )
        });

        return(
            <div className="content">
                <CommonNavbar/>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 top-pad-5">
                            <div className="card">
                                <div className="header">
                                    <h4 className="title">{campaign_header}</h4>
                                </div>
                                <div className="content">
                                    <Tabs defaultTab={variabler} vertical className="vertical-tabs">
                                        <TabList>
                                            <Tab className="tab-title" tabFor="vertical-tab-one" onClick={this.tabClicker.bind(this, 1)}>
                                                <h4 className='title'>Products</h4>
                                                <span className='text-muted'>
                                                    Selected products
                                                </span>
                                            </Tab>
                                            <Tab className="tab-title" tabFor="vertical-tab-two" onClick={this.tabClicker.bind(this, 2)}>
                                                <h4 className='title'> Schemes</h4>
                                                <span className='text-muted'>
                                                    Selected schemes
                                                </span>
                                            </Tab>
                                            <Tab className="tab-title" tabFor="vertical-tab-three" onClick={this.tabClicker.bind(this, 3)}>
                                                <h4 className='title'>  Merchants</h4>
                                                <span className='text-muted'>
                                                    Selected merchants
                                                </span>
                                            </Tab>
                                            <Tab className="tab-title" tabFor="vertical-tab-four" onClick={this.tabClicker.bind(this, 4)}>
                                                <h4 className='title'>  Details</h4>
                                                <span className='text-muted'>
                                                    Configured details
                                                </span>
                                            </Tab>
                                        </TabList>
                                        <TabPanel tabId="vertical-tab-one">
                                            <div className="card-query-builder" >
                                                <div className="col-md-12">
                                                    <div className="card noshadow" ref={this.myRef2}>
                                                        <div className="header header-promotion">
                                                            <h4 className="title">Products</h4>
                                                            <span className='text-muted'>Selected products/SKUs are part of this promotion</span>
                                                        </div>
                                                        
                                                        <div className='sweet-loading'>
                                                            <BeatLoader
                                                                css={override}
                                                                sizeUnit={"px"}
                                                                size={20}
                                                                color={'#123abc'}
                                                                loading={this.state.loading}
                                                            />
                                                        </div>                          
                                                        <div className="table-full-width table-responsive">
                                                            <div className="row m-0">
                                                                <div className="col-md-12">
                                                                    <table className="table table-striped table-hover" id="sku_showTable">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Sr No.</th>
                                                                                <th>Brand</th>
                                                                                <th>Category</th>
                                                                                <th>Model Name</th>
                                                                                <th>Model Number</th>
                                                                                <th>Model Description</th>
                                                                                <th>SKU</th>
                                                                                <th>MRP</th>
                                                                                <th>MOP</th>
                                                                                <th>Selected?</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {sku_show_data}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <br/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </TabPanel>
                                        <TabPanel tabId="vertical-tab-two">
                                        <div className="card-query-builder">
                                            <div className="col-md-12">
                                                <div className="card noshadow" ref={this.myRef2}>
                                                    <div className="header header-promotion">
                                                        <h4 className="title">Schemes</h4>
                                                        <span className="text-muted">Selected schemes are part of this promotion</span>
                                                    </div>
                                                    <div className="table-full-width table-responsive">  
                                                            <table className="table table-striped table-hover" id="brandSchemeMasterViewTable">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Scheme Name</th>
                                                                        <th>Bank Name</th>
                                                                        <th>Is Zero Cost EMI?</th>
                                                                        <th>Tenure</th>
                                                                        <th>Avail Cashback?</th>
                                                                        <th>Brand Sub</th>
                                                                        <th>Brand Sub Amount</th>
                                                                        <th>Max Cash back</th>
                                                                        <th>Time stamp</th>
                                                                        <th>Selected?</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {scheme_data_master}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </TabPanel>
                                        <TabPanel tabId="vertical-tab-three">
                                        <div className="col-md-12">

                                                <div className="card noshadow">

                                                    <div className="row">

                                                        <div className="col-md-12">
                                                            <div className="header header-promotion">
                                                            <h4 className="title">Merchants</h4>
                                                                <span className="text-muted">Selected merchants are now part of this promotion</span>
                                                            </div>
                                                            <div className="table-full-width table-responsive">  
                                                            <table className="table table-striped table-hover" id="brandMerchantMasterViewTable">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Merchant Name</th>
                                                                        <th>Merchant Code</th>
                                                                        <th>Chain Name</th>
                                                                        <th>Chain Code</th>
                                                                        <th>Store Name</th>
                                                                        <th>Store Code</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {merchant_table_displayer}
                                                                </tbody>
                                                            </table>
                                                    
                                                        </div>

                                                        <div className="footer">
                                                            <div className="stats"><i></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        </TabPanel>
                                        <TabPanel tabId="vertical-tab-four">
                                            <div className="card-query-builder subvention-brand ">
                                                <div className="col-md-12">
                                                    <div className="card noshadow" ref={this.myRef}>
                                                        <div className="header header-promotion">
                                                            <h4 className="title">Promotion Details</h4>
                                                            <span className="text-muted">The following are the promotion details</span>
                                                        </div>
                                                        
                                                        <div className= "content">
                                                            <div className="row bottompaddingsubvention">
                                                                <div className=" col-sm-6 col-md-3 col-xs-12">
                                                                <Label>Promotion Name</Label>
                                                                    <Input id="campaign_name" className="maxheighter" value={this.state.campaign_name} disabled={true}/>    
                                                                </div>
                                                                <div className=" col-sm-12 col-md-6 col-xs-12">
                                                                    <Label>Promotion Description</Label>
                                                                    <Input id="campaign_desc" className="maxheighter" value={this.state.campaign_desc} disabled={true}/>
                                                                </div>
                                                            </div>
                                                            
                                                            <div className="row bottompaddingsubvention">
                                                                <div className=" col-sm-6 col-md-3 col-xs-12">
                                                                <Label>Select start date</Label>
                                                                    <DatePicker
                                                                        dateFormat="dd-MM-yyyy"
                                                                        selected={Date.parse(this.state.startDate)}
                                                                        onChange={this.handleFromChange}
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                                <div className="col-sm-6 col-md-3 col-xs-12">
                                                                <Label>Select end date</Label>
                                                                    <DatePicker
                                                                        dateFormat="dd-MM-yyyy"
                                                                        selected={Date.parse(end_date2)}
                                                                        onChange={this.handleToChange}
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                                {/* <div className="col-sm-6 col-md-4    col-xs-12">
                                                                <Label>Maximum cashback allowed per card</Label>
                                                                <Input id="txn_value" className="maxheighter" value={this.state.maxTxnAmount} onChange={(e)=> {
                                                                    let {maxTxnAmount1} = this.state;
                                                                    maxTxnAmount1 = e.target.value;
                                                                    if(((e.target.value)*1) <= 0 || (e.target.value === '')){
                                                                        this.handleNotificationClick("tr", 3, "Insert value greater than 0");
                                                                    }
                                                                    this.setState({
                                                                        maxTxnAmount: maxTxnAmount1,
                                                                        mapField2: false
                                                                    })
                                                                }}/>    
                                                                </div> */}
                                                            </div>
                                                            {reason_giver()}
                                                            <br/>  
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </TabPanel>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
    }
}
export default NewViewPromotion;